import { atom } from 'recoil';

export const showAddNoteState = atom<boolean>({
  key: 'showAddNote',
  default: false,
});
